import { Progress, Tooltip } from "antd";
import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { CardIcons } from "../../data/wallet";
import { calculateTimeDifference } from "../../actions/helper";
import { formatAmount, getCurrentTurnoverAndRequiredTurnover, utc2offset } from "../../actions/util";
import { enumBonusRuleType, enumBonusStatus } from "../../actions/constantsData";

const AppliedCompletePromotionCard = ({item}) => {
  console.log("AppliedCompletePromotionCard", item);
  const isPostBonus = item?.bonusRuleType === enumBonusRuleType.POST;
  let txt, ico, bonusStatusId=item?.bonusStatusId, textColor="black";
  console.log("AppliedCompletePromotionCard2", item?.bonusStatusId);
  if (bonusStatusId==enumBonusStatus.Complete.ID || bonusStatusId==enumBonusStatus.ForcedToServed.ID) {
      txt = 'Đã hoàn thành';
      ico = 'compl.svg';
      textColor = "#34C759"
  } else if (bonusStatusId==enumBonusStatus.Cancelled.ID) {
      txt = 'Đã hủy';
      ico = 'expiredRed.svg';
      textColor = "#EB2121";
  } else if (bonusStatusId==enumBonusStatus.Expired.ID) {
      txt = 'Đã hết hạn';
      ico = 'expiredRed.svg';
      textColor = "#EB2121";
  }

  return (
      <div
          style={{
              display: "flex",
              flexDirection: "column",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#fff",
              padding: "16px",
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
              maxWidth: "400px",
          }}
      >
          {/* Header with Title and Icons */}
          <div
              style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "12px",
              }}
          >
              <h4 style={{ margin: 0, fontWeight: "bold" }}>
                  {item?.bonusName || "---"}
              </h4>
              <div style={{ display: "flex", gap: "8px" }}>
                  <CardIcons
                      productGroups={{
                          productGroup: item?.productGroup,
                      }}
                  />
              </div>
          </div>

          {/* Reward Amount */}
          <div
              style={{
                  marginBottom: "12px",
                  display: "flex",
                  justifyContent: "space-between",
              }}
          >
              <p style={{ margin: 0 }}>
                  {item.bonusRuleType === enumBonusRuleType.PRE
                      ? "Số tiền thưởng"
                      : "Thưởng có sẵn"}
              </p>
              <h3 style={{ margin: 0, color: "#000" }}>
                  {item?.bonusAmount} đ
              </h3>
          </div>


          {/* Progress Section */}
          <div>
              <div
                  style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                  }}
              >
                  <p
                      style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#999999",
                      }}
                  >
                      Kết thúc:{" "}
                      <span
                          style={{
                              margin: 0,
                              textAlign: "right",
                              color: "#888",
                          }}
                      >
                          {utc2offset(item?.expiredDate, 8, "YYYY/MM/DD HH:mm")}
                      </span>
                  </p>
                  <Tooltip
                      overlayClassName={"tooltip-dark"}
                      title={item?.statusTipsMessage}
                  >
                    <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: textColor,
                    }}
                    >
                    <span style={{ cursor: "pointer", marginRight:"5px" }}>
                          {!isPostBonus && (<img src={`/vn/img/1wallet/00/${ico}`} alt={ico} />)}
                      </span>{txt}
                    </div>
                  </Tooltip>
              </div>
          </div>
      </div>
  );
};

export default AppliedCompletePromotionCard;
